<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */
import { onMounted, ref } from "vue";
import type { ComplexComponentItem } from "../smartComponents/ComplexComponent/ts/Content.interface";

defineProps<{
  content: ComplexComponentItem;
}>();

const templateRef = ref<HTMLDivElement>()

onMounted(() => {
  if (!templateRef.value) return;

  templateRef.value?.querySelectorAll("img")?.forEach(el => {
    if (!el.getAttribute("alt")) {
      el.setAttribute("alt", "image")
    }
  })
})
</script>

<template>
  <article ref="templateRef" v-html="content.data" />
</template>
